export default {
  list: {
    name: "balance vip orders list api",
    version: 6,
    url: "balance-vip/orders",
    method: "GET",
  },
  accept: {
    name: "balance vip order accept api",
    version: 6,
    url: "balance-vip/orders/%{id}/accept",
    method: "POST",
  },
};
